<template>
  <div class="container card w-50 my-auto">
    <div class="row">
      <div class="col-12" align="center">
        <img
          src="../../assets/image/No data.gif"
          alt="Successful"
          width="40%"
          class="d-lg-block d-md-block d-none"
        />
        <img
          src="../../assets/image/No data.gif"
          alt="Successful"
          width="100%"
          class="d-lg-none d-md-none d-block"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12" align="center">
        <div class="h3">پرداخت ناموفق</div>
      </div>
    </div>
    <div align="center" class="mt-3">
      تا لحظاتی دیگر به سبد سفارش برمی گردید!
    </div>
    <div class="col-12" align="center">
      <div class="btn btn-dark col-lg-2 col-md-4 col-9" @click="backToCart()">
        بازگشت
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    backToCart() {
      if (this.$session.get("oldCartid")) {
        console.log(this.$session.get("oldCartid"));
      } else {
        this.$session.set("oldCartid", this.$session.get("newCartid"));
      }
      this.$router.push("/orderDetails/" + this.$session.get("newCartid"));
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.$session.get("oldCartid")) {
        console.log(this.$session.get("oldCartid"));
      } else {
        this.$session.set("oldCartid", this.$session.get("newCartid"));
      }
      this.$router.push("/orderDetails/" + this.$session.get("newCartid"));
    }, 5000);
  },
};
</script>
